var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        { attrs: { inverted: "" } },
        [
          _c("q-toolbar-title", [
            _vm._v("\n        Użytkownicy\n        "),
            _c("span", { attrs: { slot: "subtitle" }, slot: "subtitle" }, [
              _vm._v("\n          lista, wyszukiwanie, operacje\n        ")
            ])
          ]),
          _vm.getUser_groups_UserManager
            ? _c(
                "q-btn",
                {
                  attrs: {
                    flat: "",
                    dense: "",
                    color: "primary",
                    icon: "refresh"
                  },
                  on: { click: _vm.fetchData }
                },
                [_c("q-tooltip", [_vm._v("odśwież listę")])],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.getUser_groups_UserManager
        ? _c("q-table", {
            attrs: {
              title: "",
              data: _vm.items,
              columns: _vm.columns,
              "row-key": "_oid",
              pagination: _vm.pagination,
              "rows-per-page-options": _vm.rowsPerPage,
              filter: _vm.tableFilter,
              dense: "",
              separator: "cell",
              "no-data-label": "brak danych",
              "no-results-label": "brak wyników",
              "loading-label": "ładuję dane...",
              "rows-per-page-label": "rekordów na stronę",
              "selected-rows-label": function(rowsNumber) {
                return "zaznaczono " + rowsNumber + " pozycji"
              },
              "pagination-label": function(start, end, total) {
                return start + "-" + end + " z " + total
              }
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      _vm._l(props.cols, function(col) {
                        return _c(
                          "q-th",
                          {
                            key: col.name,
                            staticClass:
                              "q-title bg-indigo-1 text-weight-bolder",
                            attrs: { props: props }
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(col.label) + "\n        "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  }
                },
                {
                  key: "top-right",
                  fn: function(props) {
                    return [
                      _c("q-search", {
                        staticClass: "col-6",
                        attrs: {
                          "hide-underline": "",
                          color: "secondary",
                          placeholder: "szukaj..",
                          clearable: ""
                        },
                        model: {
                          value: _vm.tableFilter,
                          callback: function($$v) {
                            _vm.tableFilter = $$v
                          },
                          expression: "tableFilter"
                        }
                      })
                    ]
                  }
                },
                {
                  key: "body-cell-created",
                  fn: function(props) {
                    return _c("q-td", { attrs: { props: props } }, [
                      _c("small", [
                        _vm._v(_vm._s(_vm.getDateAsStr(props.value)))
                      ])
                    ])
                  }
                },
                {
                  key: "body-cell-UserName",
                  fn: function(props) {
                    return _c("q-td", { attrs: { props: props } }, [
                      _c("strong", [_vm._v(_vm._s(props.value))])
                    ])
                  }
                },
                {
                  key: "body-cell-Description",
                  fn: function(props) {
                    return _c("q-td", { attrs: { props: props } }, [
                      _c("small", [_vm._v(_vm._s(props.value))])
                    ])
                  }
                },
                {
                  key: "body-cell-VCFEMail",
                  fn: function(props) {
                    return _c("q-td", { attrs: { props: props } }, [
                      _c("small", [_vm._v(_vm._s(props.value))])
                    ])
                  }
                },
                {
                  key: "body-cell-VCFPhone",
                  fn: function(props) {
                    return _c("q-td", { attrs: { props: props } }, [
                      _vm._v("\n        " + _vm._s(props.value) + "\n      ")
                    ])
                  }
                },
                {
                  key: "body-cell-AccountDisabled",
                  fn: function(props) {
                    return _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        props.row.AccountDisabled
                          ? _c("q-icon", {
                              attrs: {
                                name: "vpn_key",
                                color: "red",
                                size: "12pt"
                              }
                            })
                          : _c("q-icon", {
                              attrs: {
                                name: "vpn_key",
                                color: "green",
                                size: "12pt"
                              }
                            }),
                        props.row.WWWDisabled
                          ? _c("q-icon", {
                              attrs: {
                                name: "public",
                                color: "red",
                                size: "12pt"
                              }
                            })
                          : _c("q-icon", {
                              attrs: {
                                name: "public",
                                color: "green",
                                size: "12pt"
                              }
                            })
                      ],
                      1
                    )
                  }
                },
                {
                  key: "body-cell-status",
                  fn: function(props) {
                    return _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        props.value === "Z"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "positive" }
                              },
                              [_vm._v("zatwierdzony")]
                            )
                          : props.value === "B"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "negative" }
                              },
                              [_vm._v("zablokowany")]
                            )
                          : props.value === "U"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "faded" }
                              },
                              [_vm._v("usunięty")]
                            )
                          : props.value === "N"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "blue-1" }
                              },
                              [_vm._v("nowy")]
                            )
                          : props.value === "N1"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "blue-2" }
                              },
                              [_vm._v("dane rejestracyjne")]
                            )
                          : props.value === "N2"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "blue-3" }
                              },
                              [_vm._v("do potwierdzenia")]
                            )
                          : props.value === "N3"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "blue-4" }
                              },
                              [_vm._v("wysłana aktywacja")]
                            )
                          : props.value === "N4"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "blue-5" }
                              },
                              [_vm._v("wyrażone zgody")]
                            )
                          : props.value === "E1"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "red-5" }
                              },
                              [_vm._v("błąd w rejestracji")]
                            )
                          : props.value === "E2"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "red-5" }
                              },
                              [
                                _vm._v(
                                  "błąd wysyłania linku rejestracyjnego przez email"
                                )
                              ]
                            )
                          : props.value === "E3"
                          ? _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "red-5" }
                              },
                              [_vm._v("błąd wysyłania hasła przez SMS")]
                            )
                          : _c(
                              "q-chip",
                              {
                                staticClass: "on-right",
                                attrs: { dense: "", color: "orange-8" }
                              },
                              [_vm._v(_vm._s(props.value))]
                            )
                      ],
                      1
                    )
                  }
                },
                {
                  key: "body-cell-_oid",
                  fn: function(props) {
                    return _c(
                      "q-td",
                      { attrs: { props: props } },
                      [
                        _c(
                          "q-btn-dropdown",
                          {
                            attrs: {
                              size: "xs",
                              rounded: "",
                              "no-wrap": "",
                              color: "indigo-7"
                            },
                            on: {
                              click: function($event) {
                                return _vm.itemAction(props.row, false)
                              }
                            }
                          },
                          [
                            _c(
                              "q-list",
                              { attrs: { link: "" } },
                              [
                                _c("q-list-header", { attrs: { inset: "" } }, [
                                  _vm._v(_vm._s(_vm.currentTitle))
                                ]),
                                _vm._l(_vm.currentActions, function(action) {
                                  return _c(
                                    "q-item",
                                    {
                                      directives: [
                                        {
                                          name: "close-overlay",
                                          rawName: "v-close-overlay"
                                        }
                                      ],
                                      key: action.label,
                                      nativeOn: {
                                        click: function($event) {
                                          return action.handler($event)
                                        }
                                      }
                                    },
                                    [
                                      _c("q-item-side", {
                                        attrs: {
                                          icon: action.icon,
                                          inverted: "",
                                          color: action.color
                                        }
                                      }),
                                      _c(
                                        "q-item-main",
                                        [
                                          _c(
                                            "q-item-tile",
                                            { attrs: { label: "" } },
                                            [_vm._v(_vm._s(action.label))]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ],
              null,
              false,
              2191000735
            )
          })
        : _vm._e(),
      _c("q-action-sheet", {
        attrs: { title: _vm.currentTitle, actions: _vm.currentActions },
        model: {
          value: _vm.actionsVisible,
          callback: function($$v) {
            _vm.actionsVisible = $$v
          },
          expression: "actionsVisible"
        }
      }),
      _c("userAddUpdate", {
        ref: "thisUserAddUpdate",
        attrs: { mode: _vm.mode }
      }),
      _c("userPasswordChange", {
        ref: "thisUserPasswordChange",
        attrs: { mode: _vm.mode }
      }),
      _c("userSendSMS", { ref: "thisUserSendSMS", attrs: { mode: _vm.mode } }),
      _c("userSendEmail", {
        ref: "thisUserSendEmail",
        attrs: { mode: _vm.mode }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }